import React, { useEffect } from 'react';
import '../CareersStyles/Careersimagemiddle.css';
import careersimagemiddle from '../BitsImages/careersimage8.webp'; // Your image path

const CareersMiddle = () => {
  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    const elements = document.querySelectorAll('[data-animate]');
    elements.forEach(el => observer.observe(el));

    return () => {
      elements.forEach(el => observer.unobserve(el));
    };
  }, []);

  return (
    <div className="careers-content-wrapper">
      <div className="careers-content">
        <div className="text-container" data-animate="slideInLeft">
          <h1 className="main-heading">
            Join Bellary Info Tech Solutions
            <br /> We Create Top-Notch Applications & Solutions
          </h1>
          <p className="quote">
            "Empowering businesses through innovative technology and strategic solutions."
          </p>
        </div>
        <div className="image-container" data-animate="slideInRight">
          <img src={careersimagemiddle} alt="Career Background" className="background-image" />
        </div>
      </div>
    </div>
  );
};

export default CareersMiddle;
